export function dropdown() {
  const dropdowns = document.querySelectorAll(".l-header__nav-dropdown");

  dropdowns.forEach(dropdown => {
    dropdown.addEventListener("click", (event) => {
      event.stopPropagation(); // イベントの伝播を防ぐ

      // 他の開いているドロップダウンを閉じる
      dropdowns.forEach(d => {
        if (d !== dropdown) {
          d.classList.remove("is-active");
        }
      });

      // 対象のドロップダウンの開閉をトグル
      dropdown.classList.toggle("is-active");
    });
  });

  // ドロップダウン外をクリックしたら閉じる
  document.addEventListener("click", () => {
    dropdowns.forEach(dropdown => {
      dropdown.classList.remove("is-active");
    });
  });

}
